<template>
  <v-navigation-drawer app fixed clipped v-model="drawer" :mobile-break-point="1100">
    <v-list>
      <v-list-group v-for="bike in allBikes" :key="bike.id">
        <v-list-tile slot="activator">
          <v-list-tile-action @contextmenu="showBikePopup($event, bike)">
            <!--<v-icon>build</v-icon>-->
          </v-list-tile-action>
          <v-list-tile-content class="subheading" @contextmenu="showBikePopup($event, bike)">
            <v-list-tile-title>{{ bike.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>


        <v-list-tile v-for="item in bike.setups" :to="{path: '/setup/' + item.id}" :key="item.id" @contextmenu="showSetupPopup($event, item)">
          <v-list-tile-action>
            <v-icon>build</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>


        <v-list-tile :to="{path: '/todos/' + bike.id}">
          <v-list-tile-action>
            <v-icon>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Todos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>

      <v-list-tile to="/springcalculator">
        <v-list-tile-action>
          <v-img class="menu-icon" src="/static/svg/calc_spring.svg"></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{$vuetify.t('$vuetify.menu.spring_calculator')}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile to="/spokecalculator">
        <v-list-tile-action>
          <v-img class="menu-icon" src="/static/svg/calc_spoke.svg"></v-img>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{$vuetify.t('$vuetify.menu.spoke_calculator')}} (Beta)</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

    </v-list>
    <v-spacer></v-spacer>
    <v-btn flat @click="clickAddBike">
      <v-icon>add</v-icon>
      {{$vuetify.t('$vuetify.add_bike')}}
    </v-btn>

    <v-menu v-model="showPopupMenu" :position-x="popupX" :position-y="popupY" absolute offset-y>
      <v-list>
        <v-list-tile v-for="item in popupMenuItems" :key="item.id" @click="clickedPopupMenu(item.id)">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>


    <v-dialog v-model="showNewDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$vuetify.t('$vuetify.' + (edit? 'edit ': 'new')) }} {{isBike ? 'Bike' : 'Setup'}}</v-card-title>

        <v-card-text>
          <v-text-field v-model="dialogContent" :placeholder="isBike ? 'Bike' : 'Setup'" @keyup.enter="dialogOk" :rules="inputRules"></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn outline flat="flat" @click="showNewDialog = false" v-if="!edit" v-html="$vuetify.t('$vuetify.cancel')">
            Cancel
          </v-btn>
          <v-btn outline color="red" flat="flat" @click="clickDeleteDialogOK" v-if="edit" v-html="$vuetify.t('$vuetify.delete')">
            Delete
          </v-btn>

          <v-btn outline flat="flat" @click="newDialogOk" v-html="$vuetify.t('$vuetify.ok')">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showDeleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$vuetify.t('$vuetify.app.dialog.delete_title')}} {{isBike ? 'Bike' : 'Setup'}}</v-card-title>

        <v-card-text>
          {{$vuetify.t('$vuetify.app.dialog.delete_start')}} {{isBike ? 'Bike' : 'Setup'}} "{{dialogContent}}" {{$vuetify.t('$vuetify.app.dialog.delete_end')}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn outline flat="flat" @click="showDeleteDialog = false" v-html="$vuetify.t('$vuetify.cancel')">
            Cancel
          </v-btn>

          <v-btn outline flat="flat" @click="clickDeleteDialogOK" v-html="$vuetify.t('$vuetify.ok')">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import String from '../mixins/StringMixin'

  export default {
    name: 'DrawerMenu',
    props: ['value'],
    mixins: [String],
    data() {
      return {
        showNewDialog: false,
        dialogContent: '',
        editItem: null,
        edit: false,
        inputRules: [
          v => !!v || this.$vuetify.t('$vuetify.errormsg.required'),
          v => v.length >= 3 || this.$vuetify.t('$vuetify.errormsg.minlength')
        ],
        showPopupMenu: false,
        popupX: 0,
        popupY: 0,
        popupMenuItems: [],
        showDeleteDialog: false,
        isBike: false,
      }
    },
    computed: {
      ...mapGetters(['allBikes']),
      drawer: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      ...mapActions(['addBike', 'updateBike', 'deleteBike', 'addSetup', 'updateSetup', 'deleteSetup', 'copySetup']),
      clickAddBike() {
        this.dialogContent = '';
        this.editItem = null;
        this.isBike = true;
        this.edit = false;
        this.showNewDialog = true;
      },
      newDialogOk() {
        if (!this.isNullOrEmpty(this.dialogContent)) {
          if (this.edit) {
            if (this.isBike) {
              this.updateBike({name: this.dialogContent, bikeId: this.editItem.id});
            } else {
              this.updateSetup({name: this.dialogContent, setupId: this.editItem.id, setup: {id: this.editItem.id}});
            }
          } else {
            if (this.isBike) {
              this.addBike({name: this.dialogContent});
            } else {
              this.addSetup({name: this.dialogContent, bikeId: this.editItem.id});
            }
          }
          this.showNewDialog = false;
        }
      },
      clickDeleteDialogOK() {
        if (this.isBike) {
          this.deleteBike({bikeId: this.editItem.id});
        } else {
          this.deleteSetup({setupId: this.editItem.id});
        }
        this.showDeleteDialog = false;
      },
      showBikePopup(e, item) {
        e.preventDefault();
        this.editItem = item;
        this.showPopupMenu = false;
        this.popupX = e.clientX;
        this.popupY = e.clientY;
        this.popupMenuItems = [{id: 'newbike', title: this.$vuetify.t('$vuetify.add_bike')}, {id: 'editbike', title: this.$vuetify.t('$vuetify.edit_bike')}, {
          id: 'deletebike',
          title: this.$vuetify.t('$vuetify.delete_bike')
        }, {
          id: 'newsetup',
          title: this.$vuetify.t('$vuetify.new_setup')
        }];
        this.$nextTick(() => {
          this.showPopupMenu = true
        })
      },
      showSetupPopup(e, item) {
        e.preventDefault();
        this.editItem = item;
        this.showPopupMenu = false;
        this.popupX = e.clientX;
        this.popupY = e.clientY;
        this.popupMenuItems = [{id: 'copysetup', title: this.$vuetify.t('$vuetify.duplicate_setup')},
          {id: 'deletesetup', title: this.$vuetify.t('$vuetify.delete_setup')},
          {id: 'renamesetup', title: this.$vuetify.t('$vuetify.rename_setup')}];
        this.$nextTick(() => {
          this.showPopupMenu = true
        })
      },
      clickedPopupMenu(e) {
        switch (e) {
          case 'newbike': {
            this.clickAddBike();
            break;
          }
          case 'editbike': {
            this.dialogContent = this.editItem.name;
            this.edit = true;
            this.isBike = true;
            this.showNewDialog = true;
            break;
          }
          case 'deletebike': {
            this.dialogContent = this.editItem.name;
            this.isBike = true;
            this.showDeleteDialog = true;
            break;
          }
          case 'newsetup': {
            this.dialogContent = '';
            this.isBike = false;
            this.edit = false;
            this.showNewDialog = true;
            break;
          }
          case 'copysetup': {
            this.copySetup({setup: JSON.parse(JSON.stringify(this.editItem))});
            this.$router.push('' + this.$store.state.lastSetup.id);
            break;
          }
          case 'deletesetup': {
            this.dialogContent = this.editItem.name;
            this.isBike = false;
            this.showDeleteDialog = true;
            break;
          }
          case 'renamesetup': {
            this.dialogContent = this.editItem.name;
            this.isBike = false;
            this.edit = true;
            this.showNewDialog = true;
            break;
          }
        }
      }
    }
  }
</script>
<style scoped>
  .v-navigation-drawer {
    display: flex;
    flex-direction: column;
  }

  .menu-icon {
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DrawerMenu.vue